var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCrossThin24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_cross_thin24x24",
    d: "M8,0a8,8,0,1,0,5.657,2.343A8,8,0,0,0,8,0ZM8,14.875a6.88,6.88,0,1,1,4.861-2.014A6.88,6.88,0,0,1,8,14.875ZM10.809,4.621a.56.56,0,0,0-.4.166L8,7.2,5.589,4.786a.563.563,0,1,0-.8.794L7.206,8,4.792,10.421a.563.563,0,1,0,.8.793L8,8.8l2.411,2.418a.562.562,0,1,0,.8-.8L8.794,8l2.413-2.42a.56.56,0,0,0-.4-.96Z",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCrossThin24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_cross_thin24x24.0ed83335a2b3a89220633d26823afd37.svg";